import { Box, Typography, Grid } from "@material-ui/core";
import { observer } from "mobx-react";
import { makeStyles, Theme } from '@material-ui/core/styles';
import { Paper, PaperBorderType, SignatureField, } from '@roc/ui';
import { useBorrowerPortalMediaQueries } from "@roc/feature-app-core";
import { TitleComp } from "libs/feature-borrowers/src/caf/components/titleComp";
import { useExternalAgentLoansStore } from "libs/feature-title-agent/src/hooks/useExternalAgentLoansStore";

const useStyles = makeStyles((theme: Theme) => {
  return {
    container: {
      flexDirection: 'column',
      justifyContent: 'center',
      textAlign: 'center',
      alignItems: 'center',
      marginTop: '20px'
    },
    button: {
      width: '160px',
      marginBottom: '50px'
    },
    margins: {
      marginTop: '20px'
    },
    sigCanvas: {
      width: "100%",
      height: 200,
      background: "#f7f7f7",
      border: "1px solid #aaa",
      borderRadius: 16,
    },
  };
});

export const VendorBankInformationSignature = observer(({ signatureRef }) => {
  const { isLargeScreen } = useBorrowerPortalMediaQueries();
  const { vendorCompanyProfileStore: { companyInformation } } = useExternalAgentLoansStore();
  return (
    <Box pb={2}>
      <Grid container spacing={2}>
        <Grid item xs={12} sm={12}>
          <Grid xs={12}>
            <Box mb={1}>
              <TitleComp title="Acknowledgments" />
            </Box>
          </Grid>
        </Grid>
        <Grid item xs={12} sm={12}>
          <Grid xs={12}>
            <Box mb={1}>
              <Typography variant={'subtitle1'}>{`On behalf of ${companyInformation?.name}, I hereby acknowledge, represent, and/or warrant as follows:`}</Typography>
            </Box>
          </Grid>
          <Grid item xs={12}>
            <Box mb={3}>
              <Paper variant="outlined" style={{ maxHeight: isLargeScreen ? 400 : 150, overflowY: "auto", padding: 24, borderColor: '#ccc' }} borderType={PaperBorderType.SOLID_BORDER}>
                <Typography variant="body1" style={{
                  fontStyle: 'italic'
                }}>
                  <ul style={{ marginLeft: '16px' }}>
                    <li style={{ marginBottom: '12px' }}>I am a duly authorized representative of the undersigned entity and have been duly authorized by such entity to execute this Standing Authorization and ACH Instructions on behalf of such entity.</li>
                    <li style={{ marginBottom: '12px' }}>The above ACH and account information is accurate and correct and I acknowledge responsibility for any errors resulting from incorrect/inaccurate information provided.</li>
                    <li style={{ marginBottom: '12px' }}>I authorize Loan Funder LLC to effect ACHs/transfers/deposits into the above specified account in connection with services provided to Loan Funder LLC.</li>

                    <li style={{ marginBottom: '12px' }}>Loan Funder LLC reserves the right to require additional verification of the above specified account information, whether written or oral, prior to authorizing a ACH/transfer/deposit, and such additional verification may delay the execution of a transfer.</li>
                    <li style={{ marginBottom: '12px' }}>The undersigned entity (1) releases Loan Funder LLC and each of its respective officers, managers, directors, consultants, agents, advisors, and representatives, from all loss, damage, liability, cost, or expense (Loss) arising out of or resulting from any action taken by Loan Funder LLC upon instructions provided under this Standing Authorization and ACH Instructions, unless the Loss arose out of Loan Funder LLC failure to exercise ordinary care, act in good faith, or act in accordance with the ACH instructions given hereunder, and (2) agrees to indemnify and hold Loan Funder LLC harmless from any Loss arising out of or resulting from any action taken by Loan Funder LLC in good faith upon instructions provided under this Standing Authorization and ACH Instructions.</li>
                    <li style={{ marginBottom: '12px' }}>Loan Funder LLC shall not be liable for refusing to execute an ACH transfer instruction based on Loan Funder LLC reasonable belief that such ACH is violative of applicable law or could cause Loan Funder LLC to incur legal liability for following such instructions.
                      Loan Funder LLC cannot guarantee the length of time it takes for funds to be credited to the above specified account after an ACH is initiated.</li>
                    <li style={{ marginBottom: '12px' }}>Loan Funder LLC does not have any influence or responsibility for fees or surcharges imposed by other financial institutions involved in the transfer of funds.</li>
                    <li style={{ marginBottom: '12px' }}>THIS STANDING AUTHORIZATION AND ACH INSTRUCTIONS SHALL BE GOVERNED BY NEW YORK LAW.</li>

                  </ul>
                </Typography>
              </Paper>
            </Box>
          </Grid>
        </Grid>
        <Grid item xs={12} sm={12}>
          <Grid xs={12}>
            <Box mb={1}>
              <TitleComp title={<span>Authorized representive Signature<Box color="red" component={"span"} ml={.5}>*</Box></span>} />
            </Box>
          </Grid>
          <Grid container spacing={2}>
            <Grid item xs={12} sm={12}>
              <SignatureField ref={signatureRef} penColor="green" />
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </Box>
  );
});